var map = {
	"./ar.yml": 97165,
	"./ca.yml": 84052,
	"./en.yml": 33677,
	"./es.yml": 30792,
	"./fr.yml": 68132,
	"./hi.yml": 53389,
	"./it.yml": 48119,
	"./nl.yml": 12094,
	"./pt.yml": 43184,
	"./ro.yml": 61117,
	"./ru.yml": 39283,
	"./sw.yml": 41230,
	"./zh.yml": 35518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68975;